"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPerformanceValue = void 0;
const createPerformanceValue = (object = {
    type: 'currency',
    value: 2,
    currency: 'JPY',
}) => object;
exports.createPerformanceValue = createPerformanceValue;
